


<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <div class="btn-toolbar mb-2 mb-md-0">    <!-- *ngIf="canAccess(['edit_users'])"-->
    <!-- <a routerLink="/plants/create" class="btn btn-sm btn-outline-secondary">Agregar</a> -->
    <button  (click)="mostrarBootstrapModal(null,'save')" class="btn btn-sm btn-outline-secondary">Agregar</button>
  </div>
</div>

<div class="table-responsive">
  <table class="table ">
    <thead>
      <tr>
        <th>#</th>
        <th>Nombre</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let plant of plants">
        <td>{{plant.id_planta}}</td>
        <td>{{plant.nom_planta}}</td>
        <td class="text-nowrap">
          
            <!-- <a href="javascript:void(0)" [routerLink]="['/plants', plant.id, 'edit']" class="btn btn-sm btn-outline-secondary">Edit</a> -->
            <a href="javascript:void(0)" (click)="mostrarBootstrapModal(plant.id,'edit')" class="btn  btn-outline-secondary mr-2"><i class="fa fa-pencil "></i></a>
            <a href="javascript:void(0)" (click)="delete(plant.id)" class="btn  btn-outline-danger"><i class="fa fa-trash-o "></i></a>
         
        </td>
      </tr>
    </tbody>
  </table>
</div>

<app-paginator
  [lastPage]="lastPage"
  (pageChanged)="refresh($event)"
></app-paginator>
